import Axios from "axios";
import { getPathName, retryRequest } from "./helper";

export const SendFormularioProductor = async(stringHtml: string) => {
    const data = {
        htmlBody: stringHtml
    };
    const headers = {
        'content-type': 'application/json',
        "Authorization": 'Bearer ' + process.env.REACT_APP_TOKEN
    }

    const axiosPostRequest = () => {
        return Axios.post(getPathName() + "/SendMailFormularioProductor", data, {
            headers: headers
        });
    };

    try {
        const response = await retryRequest(axiosPostRequest);
        return response;
    } catch (error:any) {
        console.error('Fallo de hacer varios intentos: ' + error.message);
        return error;
    }
}